export default "__VITE_ASSET__Duc24FdI__"